import { PageSizes } from 'pdf-lib';
import HelveticaRegular from '~/assets/fonts/HelveticaRegular.ttf';
import HelveticaBold from '~/assets/fonts/HelveticaBold.ttf';

export const PDF_OPTIONS: any = {
  orientation: 'p',
  unit: 'pt',
  format: 'letter',
  compress: true,
  putOnlyUsedFonts: true,
  hotfixes: ['px_scaling'],
};

export const PDF_GENERATE_HTML_OPTIONS: any = {
  autoPaging: 'text',
  html2canvas: {
    scale: 0.75,
    logging: false,
  },
  fontFaces: [
    {
      family: 'Helvetica',
      style: 'normal',
      weight: 'normal',
      src: [{ url: HelveticaRegular, format: 'truetype' }],
    },
    {
      family: 'Helvetica',
      style: 'normal',
      weight: 'bold',
      src: [{ url: HelveticaBold, format: 'truetype' }],
    },
  ],
};

export const DEFAULT_MARGIN_TOP = 20;
export const DEFAULT_MARGIN_LEFT = 20;
export const DEFAULT_MARGIN_RIGHT = 20;
export const DEFAULT_MARGIN_BOTTOM = 50;
export const PAGE_FORMAT = PageSizes.Letter;
